/// <amd-module name="Build/Common/Commands/deletedefinition/Command" />
import * as React from "react";

import { DefinitionQuality } from "Build/Client/Contracts/Build";
import { IBuildRestClient } from "Build/Client/RestClient/Build";
import { IDeleteDefinitionProps, IDeleteDefinitionState } from "Build/Common/Commands/deletedefinition/Command.types";
import { handleError } from "Build/Common/Library/ErrorHandler";

import { Dialog } from "VSSUI/Dialog";
import { FormItem } from "VSSUI/FormItem";
import { TitleSize } from "VSSUI/Header";
import { TextField } from "VSSUI/TextField";

import { ObservableValue } from "VSS/Core/Observable";
import { format } from "VSS/Core/Util/String";

import { IVssComponentProperties, VssComponent } from "VSS/Platform/Layout";

import * as Resources from "Build/Common/Commands/Resources";

class DeleteDefinition extends VssComponent<IDeleteDefinitionProps, IDeleteDefinitionState> {
    public static componentType = "ciDeleteDefinitionComponent";
    private deleteText = new ObservableValue<string>("");

    constructor(props: IDeleteDefinitionProps) {
        super(props);

        this.state = {
            deletionConfirmed: false
        };
    }

    public render() {
        let title = "";
        let message = "";
        let inputLabel = "";
        
        if (this.props.definition) {
            if (this.props.definition.quality === DefinitionQuality.Draft) {
                title = format(Resources.DeleteDraftDefinitionDialogTitle, this.props.definition.name);
                message = format(Resources.DeleteDraftDefinitionDialogMessage, this.props.definition.name);
                inputLabel = Resources.DeleteDraftDefinitionTextboxLabel;
            }
            else {
                title = format(Resources.DeleteDefinitionDialogTitle, this.props.definition.name);
                message = format(Resources.DeleteDefinitionDialogMessage, this.props.definition.name);
                inputLabel = Resources.DeleteDefinitionTextboxLabel;
            }
        }
        else if (this.props.path) {
            const pathSegments = this.props.path.split("\\");
            const folderName = pathSegments[pathSegments.length - 1];
            title = format(Resources.DeleteFolderDialogTitle, folderName);
            message = format(Resources.DeleteFolderDialogMessage, this.props.path);
            inputLabel = Resources.DeleteFolderTextboxLabel;
        }

        return (
            <Dialog
                calloutContentClassName="ci-dialog"
                onDismiss={this._onDismiss}
                footerButtonProps={[
                    {
                        onClick: this._onDismiss,
                        text: Resources.Cancel
                    },
                    {
                        disabled: !this.state.deletionConfirmed,
                        onClick: this._onCommit,
                        primary: true,
                        text: Resources.Delete,
                    }
                ]}
                titleProps={{ text: title, size: TitleSize.Large}}
                defaultActiveElement=".delete-definition-name">
                <div>{message}</div>
                <br />
                <FormItem label={inputLabel} >
                    <TextField 
                        onChange={this._onTextChanged}
                        value={this.deleteText} 
                        inputClassName="delete-definition-name"
                    />
                </FormItem>
            </Dialog>
        );
    }

    private _onCommit = () => {
        if (!this.state.deletionConfirmed) {
            return;
        }

        this.props.onClose();

        let client = this.props.pageContext.getRestClient<IBuildRestClient>("IBuildRestClient");

        if (this.props.definition) {
            let definition = this.props.definition;
            client.deleteDefinition(definition.project.id, definition.id).then(() => {
                if (this.props.onDefinitionDeleted) {
                    this.props.onDefinitionDeleted(definition);
                }
            }, handleError);
        }
        else if (this.props.path) {
            let path = this.props.path;
            client.deleteFolder(this.props.projectId, path).then(() => {
                if (this.props.onFolderDeleted) {
                    this.props.onFolderDeleted(path);
                }
            }, handleError);
        }
    }

    private _onDismiss = () => {
        this.props.onClose();
    }

    private _onTextChanged = (event: React.ChangeEvent<HTMLInputElement>, newValue: any) => {
        this.deleteText.value = newValue;

        if ((this.props.definition && this.props.definition.name === newValue) ||
            (this.props.path && this.props.path === newValue)) {
            this.setState({
                deletionConfirmed: true
            });
        }
        else {
            this.setState({
                deletionConfirmed: false
            });
        }
    }
}

VssComponent.register(DeleteDefinition.componentType, DeleteDefinition as React.ComponentClass<IVssComponentProperties>);
